module.exports = __webpack_public_path__ + "img/lotery-rewards-3.d7a255bd.webp";